import React from 'react'

import icon1 from '../assets/tint/ico_tint_clear.svg'
import icon2 from '../assets/tint/ico_tint_light.svg'
import icon3 from '../assets/tint/ico_tint_mid.svg'
import icon4 from '../assets/tint/ico_tint_max.svg'
import { connect } from 'react-redux'
import { clearTintState, setCurrentWindowTintPage, setCurrentZoneStep, setSelectedTintLevel, setSelectedWindows, setWindowTint } from '../../../../../action/roomControlAction'
import { closeOrderPopUp } from '../../../../action/hCommerce2';
import { setLoader } from '../../../../action/homeAction'

const icon_1 = icon1
const icon_2 = icon2
const icon_3 = icon3
const icon_4 = icon4

const LEVELS = [
    {
        "name" : "Clear",
        "value" : "1",
        "icon": "icon_1"
    },{
        "name" : "Light",
        "value" : "2",
        "icon": "icon_2"
    },{
        "name" : "Medium",
        "value" : "3",
        "icon": "icon_3"
    },{
        "name" : "Max",
        "value" : "4",
        "icon": "icon_4"
    },
]


function WindowZonesStep2(props) {

    return (
        <><header class="inner-pages subpages w-footer">
            <a onClick={() => {props.goBack();props.setSelectedTintLevel(1)}} class="button-back"></a>
            <div class="heading align-center">
                <p class="bold">Override</p>
            </div>
        </header>
            <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">
                <div class="widgets">
                    <div class="row">
                        <div class="col">
                            <p class="heading">Select Tint Level</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-2 menu-items">
                            {LEVELS.map(level => <a onClick={() => props.setSelectedTintLevel(level.value)} class={`tile-sm thumbnails tile-container ${props.selectedTintLevel == level.value && "selected"}`}>
                                {/* {(props.selectedTintLevel == level.value) && <i class="tint-status fa fas fa-check-circle"></i>} */}
                                <div class="thumb-img">
                                    <img src={eval(level.icon)} />
                                </div>
                                <div class="thumb-text align-center">
                                    <p class="thumb-heading">{level.name}</p>
                                </div>
                            </a>)}
                        </div>
                    </div>
                </div>
            </section>

            <footer class="button-controls">
                <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    <button class="primary w-100 all-caps margin-bottom-1" onClick={props.goNext}>Override</button>
                </section>
            </footer></>
    )
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        selectedWindows: state.store.selectedWindows,
        selectedTintLevel: state.store.selectedTintLevel
    }
}

export default connect(mapStateToProps, {setSelectedTintLevel,closeOrderPopUp, setWindowTint, setLoader, clearTintState, setCurrentWindowTintPage, setSelectedWindows, setCurrentZoneStep})(WindowZonesStep2)